<template>
  <main class="home">
    <AddContent
      v-if="activeDataList.length === 0"
      title="Add content from the side menu"
    />

    <Card
      v-else
      :title="activeDataList[activeIndex] && activeDataList[activeIndex].name"
      :key="activeDataList[activeIndex] && (activeDataList[activeIndex].name + activeDataList[activeIndex].id)"
      :tooltip="activeDataList[activeIndex] && activeDataList[activeIndex].tooltip"
      :tooltip-style="activeDataList[activeIndex] && activeDataList[activeIndex].tooltipStyle"
      :hide-left-scroll-effect="activeDataList[activeIndex] && activeDataList[activeIndex].hideLeftScrollEffect"
      :hide-right-scroll-effect="activeDataList[activeIndex] && activeDataList[activeIndex].hideRightScrollEffect"
      :hide-top-scroll-effect="activeDataList[activeIndex] && activeDataList[activeIndex].hideTopScrollEffect"
      :hide-bottom-scroll-effect="activeDataList[activeIndex] && activeDataList[activeIndex].hideBottomScrollEffect"
      :enable-scroll="getEnableScroll(activeDataList[activeIndex])"
      @delete="removeFromDataList"
      @action="getTab($event)"
    >
      <div slot="card-slot" slot-scope="slotProps">
        <Tabs
          :tab-list="tabList"
          :active-tab="activeTab.index"
          small
          @action="getTab($event)"
          :active-data="activeDataList[activeIndex]"
          v-if="activeDataList[activeIndex] && activeDataList[activeIndex].components.includes('tabs')"
        />

        <div :class="[
          'viewer-wrapper',
          { 'viewer-wrapper__tabs' : activeDataList[activeIndex] && activeDataList[activeIndex].components.includes('tabs') }
        ]">
          <ViewSelector :active-index="activeTab.index" :enableExpansion="slotProps.isExpanded" />
        </div>
      </div>
    </Card>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import model from '../content-structure';

import AddContent from '../../../jazz-components/src/components/UIComponents/AddContent.vue';
import Card from '../../../jazz-components/src/components/UIComponents/Card.vue';
import Tabs from '../../../jazz-components/src/components/UIComponents/Tabs.vue';
import ViewSelector from '../../../jazz-components/src/components/UIComponents/ViewSelector.vue';

export default {
  name: 'Home',

  components: {
    AddContent,
    Card,
    Tabs,
    ViewSelector,
  },

  data: () => ({
    data: model,

    // Tabs
    activeTab: {
      index: -1,
      label: 'MOA Tab One',
    },
    tabList: ['MOA Tab One', 'MOA Tab Two', 'MOA Tab Three'],
  }),

  computed: {
    ...mapGetters([
      'activeRoute',
      'activeDataList',
      'activeCard',
      'activeIndex',
    ]),
  },

  methods: {
    ...mapActions([
      'removeFromActiveDataList',
      'updateActiveIndex',
      'getActiveCard',
    ]),

    getTab(e) {
      this.activeTab = {
        index: e.index,
        label: e.label,
      };
    },

    removeFromDataList() {
      this.removeFromActiveDataList(this.activeCard);
    },

    getEnableScroll(currentDataList) {
      // This ensures that `enableScroll` flag is used only if it's defined as `true` or `false`
      // otherwise `undefined` ("falsy") would turn the default value to `false`
      return currentDataList?.enableScroll != null ? currentDataList.enableScroll : true;
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  height: calc(100vh - 160px);

  .log {
    @include flexbox(flex-start, space-between);
    pre {
      width: 49%;
    }
  }

  @include iPadProStyles {
    height: calc(100vh - 185px);
  }
}

.viewer-wrapper {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;

  &__tabs {
    flex: 1;
  }
}
</style>

